import { ia, io } from 'lib/helpers/utility';

import { SkeletonCellRenderer } from '../SkeletonCellRenderer';

export const isFirstColumn = (params) => {
  const displayedColumns = params.api.getAllDisplayedColumns();
  const thisIsFirstColumn = displayedColumns[0] === params.column;
  return thisIsFirstColumn;
};

export const defaultColDef = {
  minWidth: 100,
  headerCheckboxSelection: isFirstColumn,
  checkboxSelection: isFirstColumn
};

export const rowClassRules = {
  'ag-row-error': (params) => ia(params?.data?.error)
};

export const rowClassRulesGroupSelected = {
  'selected-group-row': (params) => params?.data?.isSelected
};

export const exportTableToCSV = (gridApi, categoryName) => {
  if (!gridApi) return;

  gridApi.exportDataAsCsv({
    fileName: `${categoryName || 'export'}.csv`,
    onlySelected: false,
    columnSeparator: ','
  });
};

export const getActionColumnDef = (field) => {
  if (field !== 'actions') return {};

  return {
    suppressMovable: true,
    lockVisible: true,
    suppressToolPanel: true,
    minWidth: 88
  };
};

export const getGroupedColumnField = (api, columnId) => {
  if (columnId !== 'ag-Grid-AutoColumn' || !api) return null;

  const columnState = api.getColumnState();
  const groupedColumn = columnState.find(
    (col) => col.rowGroup === true && (col.rowGroupIndex === 0 || col.rowGroupIndex === null)
  );

  if (groupedColumn) {
    const columnDefs = api.getColumnDefs();
    const columnDef = columnDefs.find((def) => {
      const defColId = def.colId || def.field;
      return defColId === groupedColumn.colId;
    });
    return {
      colId: groupedColumn.colId,
      field: columnDef?.field || groupedColumn.colId
    };
  }

  return null;
};

export const makeSkeletonRows = (length) =>
  Array.from({ length }, (_, index) => ({ index, _isSkeleton: true }));

export const skeletonGetRowId = (getRowId) => (params) =>
  params.data?._isSkeleton ? `skeleton-${params.data.index}` : String(getRowId(params));

export const applySkeletonRenderers = (colDefs) =>
  colDefs?.map((col) => ({
    ...col,
    ...(ia(col.children) ? { children: applySkeletonRenderers(col.children) } : {}),
    cellRendererSelector: (params) => {
      if (params.data?._isSkeleton) return { component: SkeletonCellRenderer };
      return col?.cellRendererSelector?.(params);
    }
  }));

export const checkIsValidClick = (isLoading, event, handler) => {
  if (isLoading || typeof handler !== 'function') return false;

  const data = event?.data;

  if (!io(data)) return false;

  if (data?._isSkeleton) return false;

  if (Object.keys(data).length === 1 && data?.index !== undefined) {
    return false;
  }

  return true;
};
